import { AppThunk } from 'store';

import { CreditFeatures } from 'types/interfaces/Credits';
import { CreditsPackage } from 'types/interfaces/CreditsPackage';
import { Package } from 'types/interfaces/Package';

import { PackagesThemeGroups } from 'api/AuthApi';
import { TrackingApi } from 'api/TrackingApi';
import {
  getSelectedUpsalesIdsFromSessionStorage,
  saveUpsalesIdsToSessionStorage,
} from 'helpers/payment/upsales';

import {
  setCredits,
  setCreditsPackages,
  setDowngradeAvailable,
  setMicroPackages,
  setPackagesTheme,
  setStopExitPackages,
  setUpgradePackages,
  setUpsalePackages,
  setVipDiscountAvailable,
  setVipPackages,
} from './paymentSlice';

const setDefaultPackAsActive = (packages: Package[] | null) =>
  Array.isArray(packages)
    ? packages.map((pack) =>
        pack.is_default ? { ...pack, active: true } : pack
      )
    : [];

/**
 * vip_packages is nullable because of discount feature
 */
export const setPackages =
  (payment: {
    packages: Package[];
    theme?: PackagesThemeGroups;
    upsale_packages: Package[];
    micro_packages?: Package[];
    vip_packages?: Package[];
    credit_packages?: CreditsPackage[];
    stop_exit_package: Package[];
    show_vip_discount?: boolean;
    credits?: {
      amount: number;
      currency: string;
      credit_features: CreditFeatures[];
    };
    to_downgrade?: boolean;
  }): AppThunk =>
  (dispatch) => {
    dispatch(setUpsalePackages(payment.upsale_packages));
    dispatch(setStopExitPackages(payment.stop_exit_package ?? []));
    dispatch(setUpgradePackages(setDefaultPackAsActive(payment.packages)));
    dispatch(setVipPackages(payment.vip_packages ?? []));
    dispatch(setMicroPackages(payment.micro_packages ?? []));
    dispatch(setCreditsPackages(payment.credit_packages ?? []));

    if (getSelectedUpsalesIdsFromSessionStorage() === null) {
      saveUpsalesIdsToSessionStorage(
        payment.upsale_packages
          .filter((upsalePack) => upsalePack.is_default)
          .map((upsalePack) => upsalePack.id)
      );
    }

    if (payment.credits) {
      dispatch(setCredits(payment.credits));
    }

    if (payment.theme) {
      dispatch(setPackagesTheme(payment.theme));
    }

    if (payment.show_vip_discount) {
      dispatch(setVipDiscountAvailable(payment.show_vip_discount));
    }

    if (payment.to_downgrade) {
      dispatch(setDowngradeAvailable(payment.to_downgrade));
    }

    if (!payment.packages || !payment.packages?.length) {
      TrackingApi.trackError({
        type: 'error',
        message: 'Empty upgrade packages was returned from init',
      });
    }
  };
